import Box from '@material-ui/core/Box';
import useLayout from '../../styles/layout'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { reserveRoutes } from '../../router/routeConfig'
import { useLocation } from 'react-router-dom'
import _, { get } from 'lodash'
import { SelectInput, TextInput, DateInput, RadioInput } from '../../components/common/components'
import { setFormValue, getReserveDate, setOptionLoading, loadPreviousVaccineData, getConformType, getReserveTime } from '../../actions'
import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import ProgressBar from '../../components/ProgressBar'
import CircularProgress from '@material-ui/core/CircularProgress';
import { doPost } from '../../utils/AjaxRequests'
import { apiPrefixUrl } from '../../utils/connection'




export default function Reserve() {

    const layoutClasses = useLayout()

    const location = useLocation();

    const idx = _.findIndex(reserveRoutes, (o) => o.path === location.pathname)

    const option = (useSelector(state => state.get("option"))).toJS()

    const form = (useSelector(state => state.get("form"))).toJS()

    const dispatch = useDispatch()

    let history = useHistory();

    useEffect(() => {
        if (!form.VACC_ID) {
            history.push('/vaccine_choice')
        }
    }, [form.VACC_ID, history])

    useEffect(() => {
        dispatch(getConformType())
    }, [dispatch])

    useEffect(() => {
        if (form.conformId && (form.BIRTHDAY && form.BIRTHDAY.length === 8) || (form.PAT_IDNO && form.PAT_IDNO.length > 9)) {
            dispatch(loadPreviousVaccineData())
        }
    }, [dispatch, form.BIRTHDAY, form.PAT_IDNO, form.conformId])

    useEffect(() => {

        dispatch(setFormValue({
            field: 'reserveDate',
            value: ''
        }))
        dispatch(setFormValue({
            field: 'reserveTimeId',
            value: ''
        }))

        if ((form.conformId && form.VACC_ID && form.DOSAGE_COUNT)) {
            dispatch(getReserveDate())
        }
    }, [dispatch, form.conformId, form.VACC_ID, form.DOSAGE_COUNT, form.PRE_VACCINE_DATE])

    useEffect(() => {
        if(form.PRE_VACCINE_REMARK && form.PRE_VACCINE_REMARK !== "有"){
            dispatch(setFormValue({
                field: "PRE_VACCINE_DATE",
                value: null
            }))
        }
    }, [dispatch, form.PRE_VACCINE_REMARK])


    useEffect(() => {
        dispatch(setFormValue({
            field: 'reserveTimeId',
            value: ''
        }))
        dispatch(getReserveTime())
    }, [dispatch, form.reserveDate])


    const handlechange = (field, value) => {

        const inputValue = field === "PAT_IDNO" ? value.toUpperCase() : value

        dispatch(setFormValue({
            field,
            value: inputValue
        }))
    }


    const handleNextClick = () => {

        // if(form.conformId === "C01" && !form.OCC_TITLE){
        //     Swal.fire("請選擇職業別", "", "error")
        //     return
        // }

        if (!form.conformId) {
            Swal.fire("請選擇接種對象類別", "", "error")
            return
        }

        // if (!form.DOSAGE_COUNT) {
        //     Swal.fire("請選擇預約施打第幾劑", "", "error")
        //     return
        // }

        if (!form.PRE_VACCINE_REMARK) {
            Swal.fire("請選擇是否施打過此疫苗", "", "error")
            return
        }

        if(form.PRE_VACCINE_REMARK === "有" && !form.PRE_VACCINE_DATE){
            Swal.fire("請選擇前一劑施打日期", "", "error")
            return
        }

        // if (form.DOSAGE_COUNT==="2" && !form.PRE_VACCINE_TYPE) {
        //     Swal.fire("請選擇第一劑施打品牌", "", "error")
        //     return
        // }

        // if ((form.DOSAGE_COUNT === "2" || form.DOSAGE_COUNT === "3" || form.DOSAGE_COUNT === "3B" || form.DOSAGE_COUNT === "B2" || form.DOSAGE_COUNT === "B3" || form.DOSAGE_COUNT === "B4") && !form.PRE_VACCINE_DATE) {
        //     Swal.fire("請選擇前一劑施打日期", "", "error")
        //     return
        // }


        if (!form.reserveDate) {
            Swal.fire("請選擇預約日期", "", "error")
            return
        }

        if (!form.reserveTimeId) {
            Swal.fire("請選擇預約時間", "", "error")
            return
        }

        if (!form.BIRTHDAY) {
            Swal.fire("請選擇出生年月日", "", "error")
            return
        }

        if (!form.PAT_IDNO) {
            Swal.fire("請選擇身分證字號", "", "error")
            return
        }

        history.push('/second_step')

        // let payload = {
        //     "api": "CDCChecker",
        //     "SCHD_ID": form.reserveTimeId,
        //     "PAT_IDNO": form.PAT_IDNO,
        //     "BIRTHDAY": form.BIRTHDAY,
        //     "CONFORM_TYPE": form.conformId,
        //     "SPNO": "",
        //     "DOSAGE_COUNT": form.DOSAGE_COUNT,
        //     "USER_ID": "PATIENT"
        // }
        // dispatch(setOptionLoading({ loading: true }))
        // doPost(apiPrefixUrl, payload)
        //     .then((rdata) => {
        //         if (rdata.status) {
        //             if (rdata.data.pass === "Y") {
        //                 Swal.fire(rdata.data.msg, "", "success")

        //             } else {
        //                 Swal.fire(rdata.data.msg, "", "error")
        //             }

        //             dispatch(setOptionLoading({ loading: false }))
        //         } else {
        //             Swal.fire(rdata.err, "", "error")
        //             dispatch(setOptionLoading({ loading: false }))
        //         }
        //     })
        //     .catch((e) => {
        //         Swal.fire("系統錯誤", "", "error")
        //         dispatch(setOptionLoading({ loading: false }))
        //     })


    }

    if (option.conform.length === 0) {
        return <div>loading...</div>
    }

    return <Box className={layoutClasses.page}>
        <Helmet>
            <title>{reserveRoutes[idx].name}</title>
        </Helmet>
        <ProgressBar />
        {/* <Typography style={{paddingBottom:"10px"}}>
            依據主管機關通知，「COVID-19疫苗接種」自2023年5月1日起由合約醫療院所收取掛號費提供接種，
            故本次接種將收取掛號費200元
        </Typography> */}
        <Paper
            elevation={3}
            square
            className={layoutClasses.paper}
        >
            <Typography variant="subtitle1" gutterBottom align="center">
                {reserveRoutes[idx].name}
            </Typography>
            <SelectInput
                label="疫苗種類"
                field="VACC_ID"
                value={form.VACC_ID}
                setValue={handlechange}
                options={JSON.stringify(option.config)}
                disabled
            />
            <SelectInput
                label="接種對象類別"
                field="conformId"
                value={form.conformId}
                setValue={handlechange}
                options={JSON.stringify(option.conform)}
            />
            <DateInput
                label="出生年月日"
                field="BIRTHDAY"
                setValue={handlechange}
                value={form.BIRTHDAY}
                variant="outlined"
            />
            <TextInput
                label="身分證字號"
                field="PAT_IDNO"
                value={form.PAT_IDNO}
                setValue={handlechange}
                variant="outlined"
            />

            <SelectInput
                label={`是否施打過此疫苗`}
                field="PRE_VACCINE_REMARK"
                value={form.PRE_VACCINE_REMARK}
                setValue={handlechange}
                options={JSON.stringify([
                    { "value": "有", "label": "有" },
                    { "value": "未曾施打", "label": "未曾施打" },
                    { "value": "施打超過84天", "label": "施打超過84天" }
                ])}
                // disabled
            // variant="standard"
            />

            {/* <SelectInput
                label={`預約施打第幾劑`}
                field="DOSAGE_COUNT"
                value={form.DOSAGE_COUNT}
                setValue={handlechange}
                options={JSON.stringify([
                    { "value": "1", "label": "一" },
                    { "value": "2", "label": "二" },
                    { "value": "3", "label": "三" }
                ])}
                // disabled
            // variant="standard"
            /> */}

            {form.PRE_VACCINE_REMARK === "有" && <DateInput
                label={`前一劑施打日期`}
                field="PRE_VACCINE_DATE"
                setValue={handlechange}
                value={form.PRE_VACCINE_DATE}
                variant="outlined"
                // disabled
            />}

            {form.DOSAGE_COUNT === "2" || form.DOSAGE_COUNT === "3" || form.DOSAGE_COUNT === "3B" || form.DOSAGE_COUNT === "B2" || form.DOSAGE_COUNT === "B3" || form.DOSAGE_COUNT === "B4" ?
                <>
                    {/* <SelectInput
                    label="第一劑施打品牌"
                    field="PRE_VACCINE_TYPE"
                    value={form.PRE_VACCINE_TYPE}
                    setValue={handlechange}
                    options={JSON.stringify(option.vaccine)}
                    // variant="standard"
                /> */}
                    {/* <p style={{color:"red", marginLeft:"10px"}}>依據指揮中心決議：不同廠牌 COVID-19 疫苗原則不建議交替使用。</p> */}

                </> : null}

            <SelectInput
                label="預約接種日期"
                field="reserveDate"
                value={form.reserveDate}
                setValue={handlechange}
                options={JSON.stringify(option.reserveDate)}
            />
            <SelectInput
                label="預約接種時段"
                field="reserveTimeId"
                value={form.reserveTimeId}
                setValue={handlechange}
                options={JSON.stringify(option.reserveTime)}
            />


            {option.loading ?
                <div style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0,0,0,0.3)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <CircularProgress size={200} />
                </div> : null}
        </Paper>
        {option.loading ? null :
            <div style={{ display: 'flex' }}>
                <Button
                    variant="contained"
                    color="secondary"
                    style={{ margin: "30px" }}
                    onClick={() => { history.push('/vaccine_choice') }}
                >
                    上一步
                </Button>
                {form.pass && <Button
                    variant="contained"
                    color="primary"
                    style={{ margin: "30px" }}
                    onClick={() => { handleNextClick() }}
                >
                    下一步
                </Button>}
            </div>
        }
    </Box>
}